module.exports = __webpack_public_path__ + "img/olamide.9cc8ebad.png";